var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ThirdPartyServiceList',{attrs:{"account-id":_vm.accountId,"third-party-services":_vm.thirdPartyServices}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }